"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserProfileRestData = exports.UserProfileDataActionType = void 0;
var RestData_1 = require("./RestData");
var urls_1 = require("../urls");
var UserProfileDataActionType;
(function (UserProfileDataActionType) {
    UserProfileDataActionType["PASSWORD_CHANGED"] = "PASSWORD_CHANGED";
    UserProfileDataActionType["PICTURE_CHANGED"] = "PICTURE_CHANGED";
})(UserProfileDataActionType = exports.UserProfileDataActionType || (exports.UserProfileDataActionType = {}));
function useUserProfileRestData(base_url, dispatch, success, fail) {
    var rest = (0, RestData_1.useRestData)(base_url, dispatch, success, fail);
    function set_picture(content) {
        var url = (0, urls_1.trailing_slash)(base_url) + urls_1.Urls.update_picture_suffix;
        var formData = new FormData();
        formData.append("picture", content);
        rest._make_request(url, {
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
        }, UserProfileDataActionType.PICTURE_CHANGED);
    }
    function change_password(old_password, new_password1, new_password2) {
        var url = (0, urls_1.trailing_slash)(base_url) + urls_1.Urls.change_password_suffix;
        var change_data = { old_password: old_password, new_password1: new_password1, new_password2: new_password2 };
        rest._make_request(url, {
            type: "POST",
            data: change_data,
        }, UserProfileDataActionType.PASSWORD_CHANGED);
    }
    return {
        read: rest.read,
        update: rest.update,
        set_picture: set_picture,
        change_password: change_password,
    };
}
exports.useUserProfileRestData = useUserProfileRestData;
